<template lang="pug">
.payment-order-qr-code-with-info
  .payment-order-qr-code
    div( v-if="!qrCodeImg && !isULPersonaType") Для генерации QR-кода заполните все поля
    div( v-if="isULPersonaType" ) QR-код недоступен для юридических лиц
    img.payment-order-qr-code_img( :src="qrCodeImg" )
  .d-flex.flex-column( v-if="isSpecifiedRegion" ) 
    span Перед оплатой Сбербанк-Онлайн 
    span не забудьте указать в банковском приложении 
    span код НПА <b>{{ caseTypePretty }}</b>
  div( v-if="isSpecifiedRegion" )
    img( :src="require(`@/assets/img/sber_${caseTypePretty}.png`)" width="350" height="350" )
</template>

<script>
import { mapState } from 'vuex'
import { PersonaType, prettyCaseType } from '../../models/payment.order.form.models'

export default {
  computed: {
    ...mapState('expert', ['qrCodeImg', 'personaType', 'region', 'caseType', 'isSber']),

    isULPersonaType() {
      return this.personaType == PersonaType.UL.value ?? null 
    },

    isSpecifiedRegion() {
      return this.qrCodeImg && this.region?.alias != 'spb' && this.region?.alias != 'msk' && this.personaType == PersonaType.FL.value && this.isSber
    },

    caseTypePretty() {
      return prettyCaseType(this.caseType)
    }
  },
}
</script>

<style scoped>
.payment-order-qr-code-with-info {
  display: flex;
  flex-direction: column;
  gap: 30px;
}
.payment-order-qr-code {
  display: flex;
  align-items: center;
  text-align: center;

  color: #BDBDBD;
  font-weight: 600;
  font-size: 20px;

  width: 350px;
  height: 350px;
  border: 10px solid #EEEEEE;

  padding: 2px;
}
.payment-order-qr-code_img {
  max-width: 330px;
  max-height: 330px;
}
</style>